import { queryOptions } from '@tanstack/react-query';

import type { DrilledDataQueryParams } from '~api/services';
import { drilledDataService } from '~api/services';

/**
 * Create query options for fetching drilled data
 * @param params - Query parameters (pattern, mine_code, planned_only)
 * @returns Query options for TanStack Query
 *
 * @example
 * const { data } = useQuery({
 *   ...drilledDataQueryOptions({ pattern: 'DFT6', mine_code: 'KAL3', planned_only: false }),
 * });
 */
export const drilledDataQueryOptions = (params: DrilledDataQueryParams) =>
  queryOptions({
    queryKey: ['drilled-data', params.pattern, params.mine_code, params.planned_only ?? false],
    queryFn: () => drilledDataService.getDrilledData(params),
  });
